import { render, staticRenderFns } from "./Funciona.vue?vue&type=template&id=af72435e&scoped=true&lang=pug&"
import script from "./Funciona.vue?vue&type=script&lang=js&"
export * from "./Funciona.vue?vue&type=script&lang=js&"
import style0 from "./Funciona.styl?vue&type=style&index=0&id=af72435e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af72435e",
  null
  
)

export default component.exports